// eslint-disable-next-line import/no-extraneous-dependencies
import * as RadixDropdown from "@radix-ui/react-dropdown-menu";
import { styled } from "@vitality-ds/system";
import BaseGroupLabelStyles from "./styles/BaseGroupLabel.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseGroupLabel = styled(RadixDropdown.Label, BaseGroupLabelStyles);